import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import PageHelmet from './PageHelmet';

const ProtectedRoute = ({ element: Component, allowedRoles = [] }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh' 
      }}>
        <div>Loading...</div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  const userRole = (user.role || '').toLowerCase();
  
  if (allowedRoles.length > 0 && !allowedRoles.includes(userRole)) {
    return <Navigate to="/dashboard" replace />;
  }

  // Dashboards, orders, submissions and admin screens are sign-in only and
  // must never be indexed. Declaring it once here covers every protected
  // route; a page that sets its own PageHelmet still wins, because it
  // renders later and react-helmet-async takes the last value.
  return (
    <>
      <PageHelmet robots="noindex,nofollow" />
      {Component}
    </>
  );
};

export default ProtectedRoute;